import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { OutlineButton } from "../../components/button/Button";
import { PropagateLoader } from "react-spinners";
import directdown from "../../assets/direct-download.gif";
import vlcplay from "../../assets/vlc.png";
const FileDisplay = ({ data, token }) => {
  useEffect(() => {
    const setShortenerTimestamp = () => {
      const lastCompletedTime = localStorage.getItem("shortenerTimestamp");
      if (lastCompletedTime) {
        const timeElapsed = Date.now() - parseInt(lastCompletedTime, 10);
        const remainingTime = 3 * 60 * 60 * 1000 - timeElapsed; // 3 hours
        if (!remainingTime > 0) {
          localStorage.setItem("shortenerTimestamp", Date.now().toString());
        }
      } else {
        localStorage.setItem("shortenerTimestamp", Date.now().toString());
      }
    };
    setShortenerTimestamp();
  }, []);
  const formatSize = (size) => {
    if (size >= 1e9) {
      return `${(size / 1e9).toFixed(2)} GB`;
    }
    return `${(size / 1e6).toFixed(2)} MB`;
  };
  const workers = [
    "https://godown.showflixmovieupload.workers.dev/",
    "https://godown.donkingsmaker.workers.dev/",
    "https://godown.videoshowflix.workers.dev/",
    "https://godown.contact-freefinder.workers.dev/",
    "https://godown.indiangovtjobseekers.workers.dev/",
  ];
  let currentWorkerIndex = 0;

  const getNextWorker = () => {
    // Round-robin strategy
    const worker = workers[currentWorkerIndex];
    currentWorkerIndex = (currentWorkerIndex + 1) % workers.length;
    return worker;
  };
  const handleDownload = (downloadUrl, token) => {
    const workerUrl = getNextWorker();
    const url = `${workerUrl}?downloadUrl=${encodeURIComponent(
      downloadUrl
    )}&token=${encodeURIComponent(token)}`;
    window.open(url, "_blank");
  };
  const openInVLC = (videoUrl, token) => {
    const workerUrl = getNextWorker(); // Replace with your function
    const url = `${workerUrl}?downloadUrl=${encodeURIComponent(
      videoUrl
    )}&token=${encodeURIComponent(token)}`;

    const userAgent = navigator.userAgent.toLowerCase();

    if (/android/i.test(userAgent)) {
      // Android (Mobile & TV)
      window.location.href = `intent:${url}#Intent;package=org.videolan.vlc;type=video/*;end;`;
    } else if (/iphone|ipad|ipod/i.test(userAgent)) {
      // iOS (iPhone, iPad)
      window.location.href = `vlc-x-callback://x-callback-url/stream?url=${encodeURIComponent(
        url
      )}`;
    } else if (/windows|mac|linux/i.test(userAgent)) {
      // PC (Windows, Mac, Linux)
      window.location.href = `vlc://${url}`;

      // Check if VLC opened, and if not, show an alert with copy option
      setTimeout(() => {
        const confirmCopy = window.confirm(
          "⚠️ VLC might not have opened automatically.\n\n" +
            "Follow these steps to open manually:\n" +
            "1. Open VLC Player\n" +
            "2. Go to 'Media' → 'Open Network Stream'\n" +
            "3. Paste the copied link and click 'Play'\n\n" +
            "Click 'OK' to copy the link."
        );

        if (confirmCopy) {
          navigator.clipboard.writeText(url);
          alert("✅ Link copied! Open VLC and paste it.");
        }
      }, 5000);
    } else {
      // Fallback: Open in a new tab
      window.open(videoUrl, "_blank");
    }
  };

  return (
    <>
      <div
        className="banner"
        style={{
          backgroundImage: `url(${
            data.children[Object.keys(data.children)[0]].thumbnail
          })`,
          height: "65vh",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      ></div>
      <div
        style={{
          padding: "20px",
          fontFamily: "Arial, sans-serif",
          marginLeft: "auto",
          marginRight: "auto",
          marginTop: "-320px",
          position: "relative",
          padding: "0 2rem",
        }}
      >
        <h1 style={{ color: "lightgreen", textAlign: "center" }}>
          Direct Download Link Generated !!!
        </h1>
        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          {Object.values(data.children).map((file) => (
            <div
              key={file.id}
              style={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                border: "1px solid #ddd",
                borderRadius: "8px",
                padding: "10px",
                boxShadow: "0px 4px 6px rgba(237, 237, 237, 0.45)",
                gap: "20px",
              }}
            >
              <img
                src={file.thumbnail}
                alt={file.name}
                style={{
                  width: "100px",
                  height: "auto",
                  borderRadius: "5px",
                  flexShrink: 0,
                }}
              />
              <div style={{ flexGrow: 1, minWidth: "200px" }}>
                <h2
                  style={{
                    margin: "0 0 10px",
                    wordBreak: "break-word",
                    fontSize: "1rem",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      alignItems: "center",
                    }}
                  >
                    <h2 style={{ fontWeight: "bold", color: "violet" }}>
                      File Name :{" "}
                    </h2>
                    <h2
                      style={{
                        fontWeight: "bold",
                        color: "lightgray",
                      }}
                    >
                      {file.name}
                    </h2>
                  </div>
                </h2>
                <div
                  style={{
                    margin: "0 0 5px",
                    wordBreak: "break-word",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      alignItems: "center",
                    }}
                  >
                    <h2 style={{ fontWeight: "bold", color: "yellow" }}>
                      Size:{" "}
                    </h2>
                    <h2 style={{ fontWeight: "bold", color: "lightgray" }}>
                      {formatSize(file.size)}
                    </h2>
                  </div>
                </div>
              </div>
              <OutlineButton
                className="butn"
                onClick={() => handleDownload(file.link, token)}
                style={{
                  flexShrink: 0,
                  padding: "5px 10px",
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                  fontSize: "0.9rem",
                }}
              >
                <img
                  style={{
                    maxWidth: "75px",
                    maxHeight: "25px",
                    borderRadius: "5px",
                  }}
                  src={directdown}
                  alt="HD Download"
                />
                <span> Download</span>
              </OutlineButton>
              <OutlineButton
                className="butn"
                onClick={() => openInVLC(file.link, token)}
                style={{
                  flexShrink: 0,
                  padding: "5px 10px",
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                  fontSize: "0.9rem",
                }}
              >
                <img
                  style={{
                    maxWidth: "75px",
                    maxHeight: "25px",
                    borderRadius: "5px",
                  }}
                  src={vlcplay}
                  alt="HD Play"
                />
                <span> Play in VLC</span>
              </OutlineButton>
            </div>
          ))}
        </div>
      </div>

      <style>
        {`
      @media (max-width: 768px) {
        .banner {
          height: 50vh !important;
        }
        h1 {
          font-size: 1.5rem;
        }
        div[style*="padding: 20px;"] {
          margin-top: -250px !important;
        }
      }
    `}
      </style>
    </>
  );
};

const GofileLinkExtractor = () => {
  const propspar = useParams();
  const downloadPageLastPart = propspar.id;
  const [contentsData, setContentsData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [token, setToken] = useState();
  const [status, setStatus] = useState("");
  // Function to fetch the token
  // const fetchToken = async () => {
  //   const tokenApiUrl = "https://api.gofile.io/accounts";
  //   setStatus("Fetching Data ...");
  //   try {
  //     const response = await fetch(tokenApiUrl, {
  //       method: "POST",
  //       referrerPolicy: "no-referrer",
  //     });
  //     const data = await response.json();
  //     if (data.status === "ok" && data.data.token) {
  //       setToken(data.data.token);
  //       setStatus("Generating Links ...");
  //       return data.data.token;
  //     } else {
  //       throw new Error("Failed to retrieve token.");
  //     }
  //   } catch (err) {
  //     throw new Error(err.message || "An error occurred while fetching token.");
  //   }
  // };

  // Function to fetch contents data
  // const fetchContentsData = async (token) => {
  //   const contentsApiUrl = `https://api.gofile.io/contents/${downloadPageLastPart}?token=${token}&wt=4fd6sg89d7s6&contentFilter=&page=1&pageSize=1000&sortField=name&sortDirection=1`;
  //   setStatus("Fetching Video Detials ...");
  //   try {
  //     const response = await fetch(contentsApiUrl, {
  //       referrerPolicy: "no-referrer", // Prevent Referer header from being sent
  //     });
  //     const data = await response.json();
  //     if (data.status === "ok" && data.data.children) {
  //       setStatus("Direct Download Link Generated !!!");
  //       console.log(data.data);
  //       return data.data;
  //     } else {
  //       throw new Error("Failed to retrieve contents data.");
  //     }
  //   } catch (err) {
  //     throw new Error(
  //       err.message || "An error occurred while fetching contents data."
  //     );
  //   }
  // };
  const filedetailsworkers = [
    "https://golist.showflixmovieupload.workers.dev/",
    "https://golist.donkingsmaker.workers.dev/",
    "https://golist.videoshowflix.workers.dev/",
    "https://golist.contact-freefinder.workers.dev/",
    "https://golist.indiangovtjobseekers.workers.dev/",
  ];

  const getNexFileDetailsWorker = () => {
    const totalWorkers = filedetailsworkers.length;
    // Check if index is already stored
    let index = localStorage.getItem("workerIndex");
    if (index === null) {
      // Pick a random starting index on first run
      index = Math.floor(Math.random() * totalWorkers);
    } else {
      // Otherwise, move to the next index
      index = (parseInt(index, 10) + 1) % totalWorkers;
    }
    // Save the new index
    localStorage.setItem("workerIndex", index.toString());
    console.log(filedetailsworkers[index]);
    return filedetailsworkers[index];
  };
  const fetchGoFileContentswithToken = async () => {
    setStatus("Fetching Video Detials ...");
    try {
      const filedetailworkerUrl = getNexFileDetailsWorker();
      const response = await fetch(
        `${filedetailworkerUrl}?id=${downloadPageLastPart}`
      );
      const result = await response.json();
      if (result.status === "success") {
        setStatus("Direct Download Link Generated !!!");
        setToken(result.token);
        return result;
      } else {
        setStatus("Failed to load data.");
        setError(result.message);
      }
    } catch (err) {
      setStatus("Error while fetching.");
      setError(err.message);
    }
  };
  // UseEffect to call the APIs on page load
  useEffect(() => {
    const fetchContentsOnLoad = async () => {
      setLoading(true);
      setError(null);
      setContentsData(null);
      try {
        // const token = await fetchToken();
        // const data = await fetchContentsData(token);
        const dataWithToken = await fetchGoFileContentswithToken();
        console.log(dataWithToken);
        setContentsData(dataWithToken.contents);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (downloadPageLastPart) {
      fetchContentsOnLoad();
    } else {
      setError("No download page last part provided.");
    }
  }, []);

  return (
    <div style={{ paddingBottom: "5rem", fontFamily: "Arial, sans-serif" }}>
      {loading && (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "700px",
              width: "100%",
            }}
          >
            <div>
              <h1 style={{ color: "#09dfeb" }}>{status}</h1>
            </div>
            <div>
              <PropagateLoader color="#09dfeb" loading="true" size={15} />
            </div>
          </div>
        </>
      )}
      {error && (
        <div style={{ color: "red", marginTop: "20px" }}>
          <strong>Error:</strong> {error}
        </div>
      )}
      {contentsData && <FileDisplay data={contentsData} token={token} />}
    </div>
  );
};

export default GofileLinkExtractor;
